import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import { AppIcon } from '@/components/AppIcon';

export function RequireAuth() {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-4">
        <AppIcon className="w-16 h-16 animate-pulse" />
        <p className="text-sm text-muted-foreground">Loading wellKept…</p>
      </div>
    );
  }

  if (status === 'anon') {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}
